var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobileOrIPad)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":30}}):_c('Lottie',{staticStyle:{"max-width":"200px"},attrs:{"options":_vm.defaultOptions,"height":140,"renderer":"svg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }